// extracted by mini-css-extract-plugin
export default {"shalinaTabs":"learningCenterTab_shalinaTabs__JFy24","custTabs":"learningCenterTab_custTabs__oESYE","custTabContent":"learningCenterTab_custTabContent__IRWIr"};